import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { isPresentationPath } from '@/lib/theme/presentation';

/** Public, author-styled presentations keep their appearance independently of the dashboard. */
export function RouteAppearanceBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return <div className="contents" data-theme-isolated={isPresentationPath(pathname) || undefined}>{children}</div>;
}
